import { useQuery } from "react-query";
import { AdminUserAccessService } from "../../../services/identity/adminUserAccess.service";
export var useAdminGetUserOrg = function (userId, enabled) {
    if (enabled === void 0) { enabled = true; }
    var query = useQuery(['allAdminOrganizationApps', userId], function () {
        return AdminUserAccessService.getOneOrg({
            userId: userId
        });
    }, {
        enabled: enabled && !!userId
    });
    return query.data;
};
